import { render } from "./musteriForm.vue?vue&type=template&id=5364edca"
import script from "./musteriForm.vue?vue&type=script&lang=js"
export * from "./musteriForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__